export const RANGE_MIN_GREATER_THAN_MAX_MESSAGE = 'Minimum cannot be greater than maximum';

/**
 * A numeric range filter is contradictory when both bounds are set and the
 * minimum exceeds the maximum. Open-ended ranges and negative values are valid.
 */
export function isRangeInvalid(min: number | undefined, max: number | undefined): boolean {
  return min !== undefined && max !== undefined && min > max;
}

/**
 * Parses a numeric range input, treating empty and partial values (e.g. a lone
 * minus sign) as "no bound" rather than NaN.
 */
export function parseRangeInput(value: string): number | undefined {
  if (value.trim() === '') return undefined;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
}

/** `isRangeInvalid` for panels that keep their range bounds as raw input strings. */
export function isTextRangeInvalid(min: string, max: string): boolean {
  return isRangeInvalid(parseRangeInput(min), parseRangeInput(max));
}
